<template>
    <div class="details mb-5">
        <div class="d-flex mb-3 align-items-center">
            <div class="bold" @click="toggleDetails">
                <i class="ico-add add-circle"></i>
                Billing details
            </div>
        </div>

        <div v-if="showDetails">
            <div class="row">
                <div class="col-sm-6">
                    <label>VAT Number</label>
                    <input type="text" class="full" v-model="details.vat">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <label>Business name</label>
                    <input type="text" class="full" v-model="details.businessName">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <label>Address</label>
                    <input type="text" class="full" v-model="details.address">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label>City</label>
                    <input type="text" class="full" v-model="details.city">
                </div>

                <div v-if="getCountries" class="col-sm-6">
                    <label>Country</label>

                    <v-select
                        v-model="selectedCountry"
                        :options="getCountries"
                        :searchable="false"
                        label="name"
                        placeholder="- Select country -"
                        @input="updateCountry">
                    </v-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        props: {
            reservation: Object,
        },
        data: function() {
            return {
                form: {

                },
                selectedCountry: null,
                showDetails: false
            }
        },
        created: function() {
            this.form = JSON.parse(JSON.stringify(this.reservation));

            if (this.form.billing === undefined || !this.form.billing) {
                this.$set(this.form, 'billing', []);
            }

            if (this.form.billing.details === undefined || !this.form.billing.details) {
                this.$set(this.form.billing, 'details', {
                    vat: '',
                    businessName: '',
                    address: '',
                    city: '',
                    country: null,
                });
            }
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'getCountries',
            ]),
            details: function() {
                return this.form.billing.details;
            }
        },
        methods: {
            toggleDetails: function() {
                this.showDetails = !this.showDetails;
            },
            updateCountry: function() {
                this.details.country = this.selectedCountry.id || null;
            }
        },
        components: {
            vSelect: extendedVSelect
        },
        watch: {
            form: {
                handler: function (n, o) {
                    console.log('Watching form changes', n.billing.details)
                    this.$emit('updateDetails', n.billing.details);
                },
                deep: true
            }
        },
    }
</script>



// WEBPACK FOOTER //
// PaymentDetails.vue?63b76858